import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import AiWebsiteGenerationBuilderFeatures from "./sections/AiWebsiteGenerationBuilderFeatures";
import ResellOrIntegrateWhiteLabelApi from "./sections/ResellOrIntegrateWhiteLabelApi";
import CustomizableWebsiteTemplates from "./sections/CustomizableWebsiteTemplates";
import VibeCodeForAnyIndustry from "./sections/VibeCodeForAnyIndustry";
import CoreFeaturesBanner from "./sections/CoreFeaturesBanner";
import GenerateCustomizePublishStepByStep from "./sections/GenerateCustomizePublishStepByStep";
import RealStoriesTestimonials from "./sections/RealStoriesTestimonials";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import MoreToolsForBusinessSuccess from "./sections/MoreToolsForBusinessSuccess";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <AiWebsiteGenerationBuilderFeatures />
      <ResellOrIntegrateWhiteLabelApi />
      <CustomizableWebsiteTemplates />
      <VibeCodeForAnyIndustry />
      <CoreFeaturesBanner />
      <GenerateCustomizePublishStepByStep />
      <RealStoriesTestimonials />
      <FrequentlyAskedQuestions />
      <MoreToolsForBusinessSuccess />
      <Footer />
    </div>;
}